"use client"
import { Typography } from "antd";
import { motion } from "framer-motion";
import Seo, { siteBase } from "../components/Seo";
import "./TermsAndConditions.css";

const { Title, Text } = Typography;

const TermsAndConditions = () => {
  return (
    <div className="terms-page">
      <Seo
        title="Terms & Conditions"
        description="The terms and conditions governing your use of Tanaka Life for airtime, data bundles and ZESA token purchases."
        canonical={`${siteBase}/terms-of-service`}
      />
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <section className="terms-hero">
          <Title level={1} className="terms-title">
            Terms & Conditions
          </Title>
          <Text className="terms-subtitle">
            Effective Date: {new Date().toLocaleDateString()}
          </Text>
        </section>

        <section className="terms-content">
          <div className="terms-section">
            <Title level={2}>Tanaka Life – Terms and Conditions</Title>
            <Text>
              Last Updated: 28/08/2025
              <br /><br />
              Welcome to Tanaka Life. By accessing our website or using our recharge services, you agree to comply with and be bound by the following Terms and Conditions ("Terms"). Please read them carefully.
            </Text>
          </div>

          <div className="terms-section">
            <Title level={2}>1. Definitions</Title>
            <Text>
              "We", "Us", "Our" refer to Tanaka Life.
              <br /><br />
              "You", "Your" refer to the customer or website user.
              <br /><br />
              "Services" means mobile airtime and data recharge, electricity tokens, vouchers, or other products made available through our website.
              <br /><br />
              "Website" means www.tanaka.co.za, our WhatsApp chatbot and any subdomains.
            </Text>
          </div>

          <div className="terms-section">
            <Title level={2}>2. Use of Services</Title>
            <Text>
              You must be at least 18 years old or have parental/guardian consent to use our services.
              <br /><br />
              Services are provided on an "as available" basis. We make no guarantees of uninterrupted access.
              <br /><br />
              You are responsible for ensuring the accuracy of the recipient details (e.g., phone number, account number). Tanaka Life will not be liable for recharges sent to the wrong number or account due to user error.
            </Text>
          </div>

          <div className="terms-section">
            <Title level={2}>3. Payments</Title>
            <Text>
              Payments can be made via accepted methods including bank transfers, card payments, and vouchers (OTT, 1Voucher, etc.).
              <br /><br />
              All payments must be made in full before a recharge is processed.
              <br /><br />
              Prices displayed include applicable taxes unless stated otherwise.
            </Text>
          </div>

          <div className="terms-section">
            <Title level={2}>4. Delivery of Recharges</Title>
            <Text>
              Recharges are typically processed instantly except for Netone data bundles but may be delayed due to network operator issues or system maintenance.
              <br /><br />
              Once a recharge is confirmed as delivered by the network operator, it is deemed successfully completed.
              <br /><br />
              We are not liable for delays caused by third-party operators, payment processors, or other service providers.
            </Text>
          </div>

          <div className="terms-section">
            <Title level={2}>5. Refunds & Cancellations</Title>
            <Text>
              No refunds will be issued once a recharge has been successfully processed.
              <br /><br />
              Refunds may be considered only if:
              <br />
              - A transaction failed but payment was still debited, and
              <br />
              - The failure is confirmed by the operator and our systems.
              <br /><br />
              Refunds are processed to your wallet if you conduct the transaction as a registered user.
              <br /><br />
              Refund requests must be submitted within 7 working days of the transaction.
            </Text>
          </div>

          <div className="terms-section">
            <Title level={2}>6. Website Use</Title>
            <Text>
              You agree not to misuse our website, including but not limited to:
              <br />
              - Attempting to gain unauthorized access.
              <br />
              - Using the website for fraudulent or unlawful purposes.
              <br />
              - Introducing malicious code or disrupting service availability.
              <br /><br />
              We reserve the right to suspend or terminate access to the website if we suspect misuse or breach of these Terms.
            </Text>
          </div>

          <div className="terms-section">
            <Title level={2}>7. Account Security</Title>
            <Text>
              You are responsible for maintaining the confidentiality of your account credentials.
              <br /><br />
              Any transactions performed under your account will be deemed authorized by you.
            </Text>
          </div>

          <div className="terms-section">
            <Title level={2}>8. Limitation of Liability</Title>
            <Text>
              Tanaka Life is not liable for:
              <br />
              - Losses due to incorrect details provided by you.
              <br />
              - Delays or failures caused by third-party service providers.
              <br />
              - Indirect, incidental, or consequential damages arising from use of our services.
              <br /><br />
              Our total liability, if established, shall not exceed the value of the transaction in question.
            </Text>
          </div>

          <div className="terms-section">
            <Title level={2}>9. Privacy & Data Protection</Title>
            <Text>
              Your personal data will be collected and processed in accordance with our Privacy Policy.
              <br /><br />
              We will not share your personal data with third parties except where required by law or to fulfill the services.
            </Text>
          </div>

          <div className="terms-section">
            <Title level={2}>10. Intellectual Property</Title>
            <Text>
              All content on our website, including logos, text, graphics, and software, is the property of Tanaka Life or its licensors.
              <br /><br />
              You may not copy, reproduce, or distribute our content without written permission.
            </Text>
          </div>

          <div className="terms-section">
            <Title level={2}>11. Amendments</Title>
            <Text>
              We reserve the right to amend these Terms at any time. Updates will be posted on our website, and continued use of our services constitutes acceptance of the revised Terms.
            </Text>
          </div>

          <div className="terms-section">
            <Title level={2}>12. Governing Law</Title>
            <Text>
              These Terms shall be governed by and construed under the laws of South Africa.
            </Text>
          </div>

          <div className="terms-section">
            <Title level={2}>13. Contact Us</Title>
            <Text>
              For queries, disputes, or support:
              <br />
              Email: ask@tanaka.co.za
              <br />
              Phone: +27815901227
            </Text>
          </div>
        </section>
      </motion.div>
    </div>
  );
};

export default TermsAndConditions;